<template>
  <div class="page-wrapper">
    <search-list class="mb16"
                @getdata="getData"
    ></search-list>
    <Button class="mb16" type="primary"
            :loading="buttonloading"
            @click.stop="downLoadAnswerRateList"
            v-p="{menu:'answerrate',api:'report/downLoadAnswerRateList'}"
    >导出</Button>
    <table-list
      title="" :columns="columns" :data="data"
      :loading="loading"
      :total="total"
      :current="current"
      @change-page="changePage"
      class = "report"
    ></table-list>
  </div>
</template>

<script>
  import SearchList from '../components/SearchList'
  import TableList from "components/TableList/index";
  import {answerRate} from "../../../api/reporter";
  import {getProjects} from "../../../api/common";
  import {formatDateTime} from "../../../utils/format";
  import subTable from './components/SubTable'
  import {downLoadAnswerRateList} from "../../../api/reporter";

  export default {
    name: "answerrate",
    components:{
      SearchList,
      TableList,
      subTable
    },
    data(){
      return {
        buttonloading:false,
        searchData: null,
        page:1,
        current: 1,
        total: 0,
        data: [],
        loading: false,
        columns: [
          {
            width:50,
            type: 'expand',
            title:' ',
            render:(h,params)=>{
              return h(subTable,{
                props:{
                  columns:this.columns,
                  params:{
                    "endTime": this.searchData.endTime,
                    "projectFids": [
                      params.row.projectFid
                    ],
                    "startTime": this.searchData.startTime,
                    "type": this.searchData.type
                  },
                }

              })
            }
          },
          {
            title: '项目名称',
            key: 'projectName',
            align: 'center',
            width: 170
          },
          {
            title: '总计',
            align: 'center',
            className: 'answer--table-border_left',

            children: [
              {
                title: '接听率',
                key: 'answerRateAll',
                align: 'center',
                className: 'answer--table-border_left',
                width: 100
              },
              {
                title: '来电量',
                key: 'incomingCallNumAll',
                align: 'center',
                width: 100
              },
              {
                title: '接听量',
                key: 'answerCallNumAll',
                align: 'center',
                width: 100
              },
            ]
          },
          {
            title: 'XB号模式',
            align: 'center',
            className: 'answer--table-border',
            children: [
              {
                title: '接听率',
                key: 'answerRateXB',
                align: 'center',
                className: 'answer--table-border_left',
                width: 100
              },
              {
                title: '来电量',
                key: 'incomingCallNumXB',
                align: 'center',
                width: 100
              },
              {
                title: '成功接听量',
              key: 'disAcceptCallNum',
                align: 'center',
                width: 100
              },
              {
                title: '管家通话中未接起',
                key: 'onCallNum',
                align: 'center',
                width: 100
              },
              {
                title: '管家无应答',
                key: 'noResponseNum',
                align: 'center',
                width: 100
              },

              {
                title: '管家拒接',
                key: 'refusedCallNum',
                align: 'center',
                width: 100
              },
              {
                title: '客户提前挂机',
                key: 'activeHangUpNum',
                align: 'center',
                width: 100
              },
              {
                title: '空号',
                key: 'spaceNumberNum',
                align: 'center',
                width: 100
              },
              {
                title: '关机',
                key: 'closeMachineNum',
                align: 'center',
                width: 100
              },
              {
                title: '无信号',
                key: 'noSignalNum',
                align: 'center',
                width: 100
              },
              {
                title: '停机',
                key: 'shutDownNum',
                align: 'center',
                width: 100
              },
              {
                title: '其他',
                key: 'failedCallNum',
                align: 'center',
                width: 100,
                className: 'answer--table-border_right',
              },
            ],
          },
          {
            title: '400模式',
            align: 'center',
            className: 'answer--table-border_left',
            children: [
              {
                title:'接听率',
                key:'answerRate',
                align: 'center',
                className: 'answer--table-border_left',
                width:100
              },
              {
                title:'来电量',
                key:'incomingCallNum',
                align: 'center',
                width:100
              },
              {
                title:'接听量',
                key:'answerCallNum',
                align: 'center',
                width:100
              },
              {
                title:'客户挂断',
                key:'customerHangUpNum',
                align: 'center',
                width:100
              },
              {
                title:'管家占线',
                key:'zoBusyNum',
                align: 'center',
                width:100
              },
              {
                title:'管家无应答',
                key:'zoNoReplayNum',
                align: 'center',
                width:100
              },
              {
                title:'无法接通',
                key:'unavailableNum',
                align: 'center',
                width:100
              },
              {
                title:'其他',
                key:'other',
                align: 'center',
                width:100
              },
            ]
          },
        ],
      }
    },
    methods:{
      downLoadAnswerRateList(){
        if(!this.searchData){
          return
        }
        this.buttonloading=true;
        downLoadAnswerRateList(this.searchData).then(res=>{
          const fileName = res.headers.filename || 'excel.xls';
          const blob = new Blob([res.data]);

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          this.buttonloading=false

        }).catch(error=>{}).finally(()=>{
          this.buttonloading=false
        })

      },
      // init() {
      //   let ret = {
      //     projectFids: [],
      //     type: 0,
      //     startTime: '',
      //     endTime: '',
      //     page: 1,
      //     limit: 10
      //   }
      //   let p1 = getProjects().then(res => {
      //     if (!res.data) {
      //       return
      //     }
      //     res.data.length > 0 && (ret.projectFids = [res.data[0].value])
      //   }).catch(error => {
      //   }).finally(() => {
      //     let date = new Date()
      //     let year = date.getFullYear()
      //     let month = date.getMonth()
      //     let day = date.getDate()
      //     ret.startTime = formatDateTime(new Date(year, month, day - 7), false)
      //     ret.endTime = formatDateTime(new Date(year, month, day - 1), false)
      //     this.searchData = ret
      //     this.answerRate()
      //
      //   })
      // },
      answerRate(){
        const params={
          ...this.searchData,
          page:this.page,
          limit:10
        };
        answerRate(params).then(res=>{
          if(!res.data){
            return
          }
          // 总计 projectFid 并不为空
          res.data.list.forEach((ele)=>{
            if(!ele.projectFid || ele.projectFid === 'zongji'){
              ele['_disableExpand'] = true
            }
          });
          this.data=res.data.list;
          this.total=res.data.total
        })
      },
      getData(params){
        this.current=1;
        this.page=1;
        this.searchData=params;
        this.answerRate()
      },
      changePage(n){
        this.current = n;
        this.page = n;
        this.answerRate()
      }
    },
    created(){
      // this.init()
    }
  }
</script>

<style>
.answer--table-border{
  border-left: 1px solid rgb(217, 215, 218);
  border-right: 1px solid rgb(217, 215, 218);
}

.answer--table-border_left{
  border-left: 1px solid rgb(217, 215, 218);
}

.answer--table-border_right{
  border-right: 1px solid rgb(217, 215, 218);
}
</style>
